import { graphql } from "gatsby"

export const BblIntroImageColumnsBlockFragment = graphql`
  fragment BblIntroImageColumnsBlock on WpBlock {
    ... on WpBblIntroImageColumnsBlock {
      name
      attributes {
        className
      }
    }
  }
`

// This is the string version of this that is used within previews and without WP prefixes
export const BblIntroImageColumnsBlockPreview = `
    ... on BblIntroImageColumnsBlock {
        name
        attributes {
            className
        }
    }
`
